import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import './styles.css';

// import required modules
import { Autoplay, EffectCoverflow, Pagination } from 'swiper/modules';
import Ratings from './components/Ratings';
import vw from './assets/images/vw.jpg';
import vgp from './assets/images/aus/vgp.png';
import ausgov from './assets/images/aus/ausgov.png';
import nti from './assets/images/aus/nti.svg';
import fixtrading from './assets/images/fixtrading.webp';
import cbn from './assets/images/aus/CBN_Logo.svg'
import schneider from './assets/images/aus/schneider.png';
import dfat from './assets/images/aus/dfat.png';
import pharmaaus from './assets/images/aus/pharmaaus.png';
import victoria from './assets/images/aus/victoria.png';
import queensland from './assets/images/aus/queensland.png';
import nsw from './assets/images/aus/nsw.png';
import fwcl from './assets/images/aus/fwcl.png';
import dmtc from './assets/images/aus/dmtc.png';
import djcs from './assets/images/aus/djcs.png';

import adnoc from './assets/images/middleEast/adnoc.png';
import agu from './assets/images/middleEast/agu.png';
import alhussaini from './assets/images/middleEast/alhussaini.png';
import caa from './assets/images/middleEast/caa.png';
import awrostamani from './assets/images/middleEast/awrostamani.png';
import ccq from './assets/images/middleEast/ccq.png';
import du from './assets/images/middleEast/du.png';
import emiratesTransport from './assets/images/middleEast/emiratesTransport.png';
import enec from './assets/images/middleEast/enec.png';
import entertainment from './assets/images/middleEast/entertainment.png';
import nahdi from './assets/images/middleEast/nahdi.svg';
import nbb from './assets/images/middleEast/nbb.png';
import pensionFund from './assets/images/middleEast/pensionFund.png';
import pif from './assets/images/middleEast/pif.png';
import qatar from './assets/images/middleEast/qatar.png';
import salama from './assets/images/middleEast/salama.png';
import scfa from './assets/images/middleEast/scfa.png';
import tawazun from './assets/images/middleEast/tawazun.png';
import wtc from './assets/images/middleEast/wtc.png';

import cg from './assets/images/europe2/cg.png';
import dos from './assets/images/europe/dos.png';
import also from './assets/images/europe/also.png';
import thales from './assets/images/europe2/thales.png';
import itu from './assets/images/europe/itu.png';
import legrand from './assets/images/europe2/legrand.png';
import otto from './assets/images/europe2/otto.png';
import prodware from './assets/images/europe2/prodware.png';
import dedalus from './assets/images/europe/dedalus.png';
import italia from './assets/images/europe2/italia.png';
import belimo from './assets/images/europe2/belimo.png';

import dbs from './assets/images/dbs.png';
import png from './assets/images/png.png';
import hal from './assets/images/hal.png';
import flipkart from './assets/images/flipkart.png';
import honda from './assets/images/honda.png';
import lnt from './assets/images/lnt.png';
import pnb from './assets/images/pnb.png';
import rp from './assets/images/rp.png';
import walmart from './assets/images/walmart.png';
import starbucks from './assets/images/starbucks.png';
import servicenow from './assets/images/servicenow.png';

export default function TestimonialsTemp() {

const testimonials = [
    {
        title: "Strategic Planning And User Training Key To Successful Implementation Of MiniOrange Plugin",
        subText: "It is very helpful to our oraganization to use both internal and external users are managing with this plugin.",
        industry: "Energy and Utilities",
        firmSize: "30B + USD",
        rating: "5.0"
      },
      {
        title: "Great Service For Multifactor Authentication.",
        subText: "The team at miniOrange has been great with supporting our needs for MFA within our organization. The support staff are knowledgeable and very easy to communicate with if an issue or question arises.",
        industry: "Healthcare and Biotech",
        firmSize: "<50M USD",
        rating: "5.0"
      },
      {
        title: "Want 2FA, Get Mini Orange! Want Great Support? Get Mini Orange!",
        subText: "The support from miniOrange was great. What was promised to me, we received. Did not waste a minute on the call to set this up and quick.",
        industry: "Travel and Hospitality",
        firmSize: "<50M USD",
        rating: "5.0"
      },
      {
        title: "miniOrange - A Very Efficient Solution To Manage Users And Their Access",
        subText: "miniOrange IAM have easy to use interface along with it robust security features, it also have really good customer support.",
        industry: "IT Services",
        firmSize: "<50M USD",
        rating: "5.0"
      },
      {
        title: "Looking For A Top-Notch Cybersecurity Company That Specializes In MFA?",
        subText: "miniOrange is a great product at IAM, flexible to deployment (On-premise, Cloud,..)",
        industry: "IT Services",
        firmSize: "<50M USD",
        rating: "5.0"
      },
      {
        title: "Excellent Identity Product That Covers Everything You Would Ever Need",
        subText: "Excellent Identity Solution that covers every corner",
        industry: "Hardware",
        firmSize: "50M - 250M USD",
        rating: "5.0"
      },
      {
        title: "miniOrange Support Is Like Having White-Glove Concierge IT Service.",
        subText: "I can't speak highly enough regarding miniOrange, totally satisfied with the process and results in every regard. SSO, SAML IDP, MultiFactor Auth and much more.",
        industry: "Finance (non-banking)",
        firmSize: "<50M USD",
        rating: "5.0"
      }
] 

  return (
    <div className='d-flex flex-column' style={{height:'91vh'}}>
    
    <h4 className='text-center my-4 py-1'>Customers</h4>
    <div className='w-100 logos'>
    <div className='logos-slide'>
    <img src={dbs} height={70} />
    <img src={png} height={70} />
    <img src={hal} height={80}/>
    <img src={flipkart} height={80} />
    <img src={pnb} height={80}/>
    <img src={rp} height={80} />
    <img src={walmart} height={80}/>
    <img src={starbucks} height={80}/>
    <img src={honda} height={80} />
    <img src={lnt} height={80}/>
    <img src={servicenow} height={50}/>
    </div>
    <div className='logos-slide'>
    <img src={dbs} height={70} />
    <img src={png} height={70} />
    <img src={hal} height={80}/>
    <img src={flipkart} height={80} />
    <img src={pnb} height={80}/>
    <img src={rp} height={80} />
    <img src={walmart} height={80}/>
    <img src={starbucks} height={80}/>
    <img src={honda} height={80} />
    <img src={lnt} height={80}/>
    <img src={servicenow} height={50}/>
    </div>
    </div>
    
    
    <h4 className='text-center my-4 py-1'>Testimonials</h4>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        slidesPerView={'auto'}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 150,
          modifier: 2.5,
          slideShadows: true,
        }}
        autoplay = {{
            delay:5000,
    disableOnInteraction:true,
        }}
        modules={[EffectCoverflow, Pagination, Autoplay]}
        className="mySwiper"
      >
        {testimonials.map((testimonial)=>{
            return(
<SwiperSlide>
        <div className='bg-light bg-opacity-25 p-5 text-white rounded d-flex flex-column  justify-content-center h-100' style={{ background: `linear-gradient(141.39deg, #EB5424 0.83%, #972400 27.38%, #320C00 81.27%)`, height:400}}>
        <Ratings rating={testimonial.rating} />
                                {/* <h6 className='lh-lg mb-4 fw-bold'>{testimonial.title}</h6> */}
                                <p className='lh-lg  fw-normal fst-italic mb-0' style={{color:"#dcdcdc"}}>{testimonial.subText}</p>
                                <div className='row'>
                                    <div className='col-6'>
                                    <div className='my-2'>
                                        <small style={{color:'#FF5E1F'}}>industry</small>
                                        </div>
                                        <p className='mb-1 text-14'>{testimonial.industry}</p>
                                        
                                    </div>

                                    <div className='col-6'>
                                    <div className='my-2'>
                                        <small style={{color:'#FF5E1F'}} className="text-12">Company Size</small>
                                        </div>
                                    <small className='mb-1 text-14'>{testimonial.firmSize}</small>
                                    
                                    </div>
                                </div>
                            </div>
        </SwiperSlide>
            )
        })}


      </Swiper>
    
    
    </div>
  );
}
